import dayjs from "dayjs"
import dayjs_plugin_timezone from "dayjs/plugin/timezone"
import dayjs_plugin_utc from "dayjs/plugin/utc"

dayjs.extend(dayjs_plugin_utc)
dayjs.extend(dayjs_plugin_timezone)

export type XAxisTickFormat = "date" | "time"

export const getXAxisTickFormat = (labelX: string): XAxisTickFormat => (labelX === "Hours" ? "time" : "date")

export const formatMonitoringXAxisTick = (
  label: string | number | undefined,
  format: XAxisTickFormat,
  timeZone: string,
) => {
  const date = dayjs(label)

  if (!label || !date.isValid()) {
    return label ?? ""
  }

  return date.tz(timeZone || "UTC").format(format === "time" ? "HH:mm" : "DD-MMM")
}

export const getGroupedTimestampLabels = (
  historicalData: { key_as_string: string }[],
  intervalItemsCount: number,
  fallbackCount: number,
) => {
  const labels = historicalData.filter((_, index) => index % intervalItemsCount === 0).map(item => item.key_as_string)

  if (labels.length > 0) {
    return labels
  }

  return [...Array(fallbackCount)].map((_, index) => String(index + 1))
}
